# creation:
- description:
    en: collection of articles about PhD life written in Japanese.
    ja: CS博士課程のサバイブに役立ちそうな記事リスト.
  img: awesome-cs-ja-phd-life
  links:
    - title: github
      url: https://github.com/Kei18/awesome_cs-ja_phd_life
  month: 7
  title: Awesome CS-Ja PhD Life
  year: 2022
# - description:
#     en: "[Cha]racter pattern formation generator powered by A[mplify]."
#     ja: 文字遷移のリアルタイムアニメーション生成. Amplify Hackathonの優秀賞.
#   img: champlify
#   links:
#     - title: code
#       url: https://github.com/Kei18/champlify
#   month: 3
#   title: Champlify
#   year: 2021
# - description:
#     en: Experimental book about human-like intelligence that collaborated with 6 interdisciplinary
#       explorers.
#     ja: 同年代6人(研究者やアーティスト, 医者や哲学者)が人間の知能ってこんなものなのではないか?と議論した内容をまとめた自費出版した本.
#   img: bug-generator
#   links:
#     - title:
#         en: Article (Japanese)
#         ja: 解説記事
#       url: https://medium.com/@Kei18/bug-generator-%E3%81%A8%E3%81%84%E3%81%86%E6%9C%AC%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6-9464937f4235
#   month: 11
#   title:
#     en: Bug Generator
#     ja: Bug Generator
#   year: 2016
# - description:
#     en: Smart white-cane device which tells users what and where obstacles are.
#     ja:
#       チームメンバーのいとこが生まれながら目が不自由であることを知って開発したスマート白状. 目の前にどんな障害物があるかを教えてくれる. JPHACKS2016を始めとして受賞多数.
#       デバイスの制御を担当.
#   img: walky
#   links:
#     - title:
#         en: Description (Japanese)
#         ja: 説明
#       url: https://devpost.com/software/tk_1621
#     - title:
#         en: Demo
#         ja: デモ
#       url: https://www.youtube.com/watch?v=IPwSHgdlTRA
#   month: 11
#   title:
#     en: Walky
#     ja: Walky
#   year: 2016
# - description:
#     en: Full automation internet radio that a bot plays a virtual DJ. Microsoft Imagine
#       Cup 2017 finalist in Japan region.
#     ja: ボットがパーソナリティをつとめるインターネットラジオ. Imagine Cup 2017日本大会ファイナリスト. 全体設計とクライアントサイドを担当.
#   img: botio
#   links:
#     - title:
#         en: Article (Japanese)
#         ja: 解説記事
#       url:
#         en: http://mspjp.hatenablog.com/entry/ICJP17/MSP
#         ja: http://mspjp.hatenablog.com/entry/ICJP17/MSP
#     - title:
#         en: Presentation
#         ja: プレゼンテーション
#       url:
#         en: https://youtu.be/8NxlewE88vs
#         ja: https://youtu.be/8NxlewE88vs
#   month: 3
#   title:
#     en: BOTIO
#     ja: BOTIO
#   year: 2017
# - description:
#     en: What happens when two persons share visions through HMDs while moving?
#     ja: 無機質な情報ではなく, 意思をもった個体の感覚(視界)を共有すると何ができるかどうかを探ってみた作品.
#   img: sharing-vision
#   links:
#     - title:
#         en: Demo
#         ja: デモ
#       url: https://youtu.be/mvnxW4cEAPI
#   month: 9
#   title:
#     en: Sharing Vision
#     ja: 視覚の相互侵入型ネットワーク
#   year: 2016
# - description:
#     en: Real-time telecommunication system using pseudo hologram.
#     ja: スターウォーズのホログラム通信を実現してみたかった. HackU@東工大の東工大賞. 全体設計とカメラ周りを担当.
#   img: holochat
#   links: []
#   month: 5
#   title:
#     en: HoloChat
#     ja: HoloChat
#   year: 2016
# - description:
#     en: Interactive projection mapping with gestures of visitors.
#     ja: 調布の布多天神社という場所で行った, 参拝者の仕草に合わせたインタラクティブなプロジェクション.
#   img: projection-mapping
#   links:
#     - title:
#         en: Homepage (Japanese)
#         ja: ホームページ
#       url: http://akaripj.tokyolighting.com/
#   month: 11
#   title:
#     en: Projection Mapping at Shrine
#     ja: 布田天神社あかり計画
#   year: 2015
# - description:
#     en: IoT shooting game. Exhibited at Maker Faire Tokyo 2015.
#     ja: スプラトゥーンにインスパイアされて作った, 霧吹きで相手に'色をかける'ゲーム. Maker Faire Tokyo 2015出展. ヴィジュアライゼーションアプリを担当.
#   img: colors-of-msp
#   links:
#     - title:
#         en: Article (Japanese)
#         ja: 記事
#       url: https://www.itmedia.co.jp/pcuser/articles/1508/12/news037_2.html
#   month: 8
#   title:
#     en: Colors of MSP
#     ja: Colors of MSP
#   year: 2015
